module.exports = __webpack_public_path__ + "static/media/3.6c7f81ba.png";